module.exports = __webpack_public_path__ + "73f6cc553b39f08a3dba516b8a7290ce.svg";